import { TrustpilotTestimonialMobile } from "./TrustpilotTestimonialMobile";

export { TrustpilotTestimonialMobile };
